import QualityChecklist from "../../components/setup/Quality/CheckList";

const Index = () => {
    return <QualityChecklist />
}

export default Index;